import { render, staticRenderFns } from "./MyPlan.vue?vue&type=template&id=6b4095bc&scoped=true"
import script from "./MyPlan.vue?vue&type=script&lang=js"
export * from "./MyPlan.vue?vue&type=script&lang=js"
import style0 from "./MyPlan.vue?vue&type=style&index=0&id=6b4095bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4095bc",
  null
  
)

export default component.exports